import { patientService } from '@/services/patient-service'
import { MyActiveOrganization } from '@/helpers/my-account-helper'
import { normalize, denormalize } from 'normalizr'
import { schemas } from '@/store/schemas'

export const mutations = {
  ['SET_SELECTED_PATIENT'](state, patient) {
    state.selectedPatient = patient
    const result = normalize(patient, schemas.patient)
    state.patients = { ...state.patients, ...result.entities.patients }
  },
  ['SET_FETCHING_SELECTED_PATIENT'](state, fetching) {
    state.fetchingSelectedPatient = fetching
  }
}

export const actions = {
  async ['GET_PATIENT']({ commit }, { patientId }) {
    commit('SET_FETCHING_SELECTED_PATIENT', true)
    const response = await patientService.findById(MyActiveOrganization.id, patientId)
    commit('SET_SELECTED_PATIENT', response.data)
    commit('SET_FETCHING_SELECTED_PATIENT', false)
    return response.data
  }
}

export const getters = {
  getDenormalizedPatient: (state, getters) => id => {
    return denormalize(id, schemas.patient, getters.getNormalizedState())
  }
}
